var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecondary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 225.03 228.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f4f4f4;\n      }\n\n      .cls-2 {\n        fill: #8b6a4f;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -4.29,
    y: -3.85,
    width: 234.14,
    height: 237.32
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "146.6 78.48 145.57 72.52 128.45 72.52 128.45 50.7 121.6 49.62 121.6 72.52 79.46 72.52 78.43 78.48 96.58 78.48 96.58 118 103.44 119.1 103.44 78.48 121.59 78.48 121.59 103.15 128.45 104.25 128.45 78.48 146.6 78.48"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 86.49,
    y: 168.72,
    width: 1.56,
    height: 9.92
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "100.08 177.27 94.94 168.72 92.72 168.72 92.72 178.64 94.13 178.64 94.13 170.11 99.24 178.64 101.49 178.64 101.49 168.72 100.08 168.72 100.08 177.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "113.41 169.98 113.23 168.72 106.18 168.72 106.18 178.64 107.72 178.64 107.72 174.85 112.29 174.85 112.29 173.61 107.72 173.61 107.72 169.98 113.41 169.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.18,171.7c0-1.87-1.18-2.98-3.56-2.98h-4.3s0,9.92,0,9.92h1.56s0-3.93,0-3.93h2.14s2.93,3.93,2.93,3.93h1.87s-3.2-4.12-3.2-4.12c1.69-.36,2.57-1.42,2.57-2.82ZM118.85,173.49v-3.51h2.57c1.48,0,2.21.58,2.21,1.74s-.84,1.78-2.32,1.78h-2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.86,168.72l-4.24,9.92h1.58s.91-2.23.91-2.23h4.9s.9,2.23.9,2.23h1.66s-4.14-9.92-4.14-9.92h-1.57ZM131.59,175.22l1.99-4.86,1.96,4.86h-3.95Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "174.88 174.45 149.24 174.45 149.24 172.85 174.6 172.85 174.88 174.45"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "50.16 174.45 75.8 174.45 75.8 172.85 50.43 172.85 50.16 174.45"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 49.62,
    y: 129.73,
    width: 4.43,
    height: 28.27
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "81.88 154.1 67.26 129.73 60.97 129.73 60.97 158 64.95 158 64.95 133.72 79.49 158 85.96 158 85.96 129.73 81.88 129.73 81.88 154.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.51,150.73c0-4.79-2.84-7.09-10.19-9.13-5.76-1.59-7.27-2.92-7.27-5.32s2.48-3.63,6.29-3.63c3.46,0,7.09.89,10.28,2.13l-.62-4.25c-3.46-1.06-6.38-1.51-9.66-1.51-7.09,0-10.81,3.1-10.81,7.53,0,4.61,2.75,7,9.92,8.95,5.85,1.51,7.53,2.75,7.53,5.49s-2.3,4.17-7,4.17c-3.37,0-7.09-.8-10.72-2.22l.71,4.16c2.22.71,5.58,1.68,10.37,1.68,7.27,0,11.17-3.19,11.17-8.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 119.19,
    y: 129.73,
    width: 4.43,
    height: 28.27
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "158.66 154.45 158.66 145.33 171.25 145.33 171.25 141.78 154.23 141.78 154.23 158 174.88 158 175.41 154.45 158.66 154.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "175.14 133.36 142.31 133.36 142.31 158 137.88 158 137.88 133.36 128.31 133.36 128.84 129.73 174.7 129.73 175.14 133.36"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondary);
export default __webpack_public_path__ + "static/media/Secondary.4faf286606c0d475c7d543c9c06353f1.svg";
export { ForwardRef as ReactComponent };